import { simplePath } from "../../utils.js";
const DELETE_PROFILE_SETTINGS_DEACTIVATE = 'v2/user-profile-settings/deactivate';
function del_profile_settings_deactivate_path() {
    return simplePath(DELETE_PROFILE_SETTINGS_DEACTIVATE, {});
}
export { DELETE_PROFILE_SETTINGS_DEACTIVATE, del_profile_settings_deactivate_path };
